<div class="dialog-container">
  <div class="icon">✅</div>

  <h2>¡Pedido realizado!</h2>

  <p>
    Tu pedido fue enviado correctamente.<br />
    En breve nos comunicamos con vos 🍔
  </p>

  <button class="ok-btn whatsapp" (click)="enviarWhatsApp()">
    Enviar por WhatsApp
  </button>
</div>
